import React from 'react';
import ReactGA from 'react-ga';

import GA from '../../../services/ga_events';
import './chromecast_button.scss';

export default class CastButton extends React.Component {
  constructor(props) {
    super(props);
    this._castButton = null;
  }

  render() {
    return (
      <div className="chromecast-button">
        <button
          className="th-cast-button"
          label="Cast"
          onClick={() => {
            ReactGA.event(GA.cast);
            if (this._castButton) {
              this._castButton.click();
            }
          }}
        >
        CAST
        </button>
        <div className="google-cast-button">
          <button
            is="google-cast-button"
            ref={(button) => { this._castButton = button; }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/chromecast/button/chromecast_button.jsx